import { SkillsFilter } from '~/features/common';
import { useSearch } from '../../providers';

export const AdvancedSearchFilterSkills = () => {
  const { selectedSkills, setSelectedSkills, availableSkills, isLoadingSkills } = useSearch();

  return (
    <SkillsFilter
      skills={availableSkills}
      selectedSkills={selectedSkills}
      onSelectedSkillsChange={setSelectedSkills}
      onSelectedSkillsClear={() => setSelectedSkills([])}
      isLoading={isLoadingSkills}
      size="md"
    />
  );
};
